import React, { Component } from 'react'
import { CSVLink } from "react-csv";
import * as moment from 'moment'

class SibicCSV extends Component {

    state = {
        records: []
    }

    componentDidMount() {
        var refer_records = []
        this.props.records.records.forEach(record => {
            if (record.records_reference.length !== 0) {
                record.records_reference.forEach(refer => {
                    refer_records.push(Object.assign(refer, record));
                })
            } else {
                refer_records.push(record)
            }
        })
        this.setState({ records: refer_records })

    }

    render() {

        if (!this.props.records.records || !this.props.records.records.length) return null

        const headers_csv = [
            { label: "Specie ID", key: "species_id" },              //Col 1
            { label: "Taxonomic group", key: "taxonomic_group" },   //Col 2
            { label: "Country", key: "country" },                   //Col 3
            { label: "Stretch place", key: "stretch_place" },       //Col 4
            { label: "Locality", key: "locality" },                 //Col 5
            { label: "Author", key: "author" },                     //Col 9
            { label: "Year", key: "year" },                         //Col 10
            { label: "Latitude", key: "latitude" },                 //Col 14
            { label: "Longitude", key: "longitude" }                //Col 15
        ];

        var array_csv = this.state.records.map(record => {
            return {
                species_id: record.species_id,              //Col 1
                taxonomic_group: record.taxonomic_group,    //Col 2
                country: record.country,                    //Col 3
                stretch_place: record.stretch_place,        //Col 4
                locality: record.locality,                  //Col 5
                author: record.author,                      //Col 9
                year: record.year,                          //Col 10
                latitude: record.latitude,                  //Col 14
                longitude: record.longitude                 //Col 15
            };
        })

        return (
            <CSVLink
                data={array_csv}
                filename={`SIBIC__${this.props.id_specie}_${moment().format('DD-MM-YYYY')}.csv`}
                headers={headers_csv} separator={";"}
                className="btn btn-success text-dark mt-3 mb-3" style={{fontSize: 15}}>
                    <span>{this.props.t("ficha-csv-sibic")}({this.props.records.records.length}) *</span>
            </CSVLink>
        );
    }
}

export default SibicCSV

//Descargar los registros de SIBIC en CSV ({array_csv.length}) *
